<template>
    <div class="dark-blue hero">
    
      <v-container class="px-10 mt-lg-10 mt-xs-6 mt-sm-8 mt-md-8 pt-12 d-flex align-center justify-center fill-height" fluid>
        <v-row cols="12">
            <v-col cols="2"></v-col>
            <v-col cols="12" md="5" class="d-flex justify-center flex-column">
                <h1 class="section__header-title white--text text-h2 font-weight-bold">Workflows</h1>
                <h2 class="white--text text-h5 font-italic mb-5">If it can be done, it can be automated.</h2>
                <h2 class="white--text text-subtitle-1">From customer journeys to cross-platform integrations, our platform acts as the glue between your systems. Automate repetitive tasks, orchestrate complex workflows, and free your team to focus on what matters most.
                </h2>
            </v-col>
            <v-col cols="12" md="5">
            </v-col>
            
        </v-row>
        
      </v-container>
    </div>
  </template>
  
<script>
    export default {
    name: 'CampaignsHero',
    }
</script>

<style lang="scss">


</style>
  